
import React from 'react';
import { TrendingUp, CheckCircle, Target } from 'lucide-react';
import { CompetenceData } from '../../data/competencesData';

interface CompetenceResultsProps {
  resultats: CompetenceData['resultats'];
  outils: CompetenceData['outils'];
}

const CompetenceResults = ({ resultats, outils }: CompetenceResultsProps) => {
  return (
    <div className="grid md:grid-cols-2 gap-8 mb-12">
      {/* Résultats */}
      <div className="bg-white border border-navy-100 rounded-2xl p-6 shadow-lg">
        <h3 className="text-xl font-semibold text-navy-900 mb-4 flex items-center gap-2">
          <TrendingUp className="text-green-600" size={20} />
          Résultats obtenus
        </h3>
        <ul className="space-y-3">
          {resultats.map((resultat, index) => (
            <li key={index} className="flex items-start gap-2 text-navy-600">
              <CheckCircle className="text-green-600 flex-shrink-0 mt-0.5" size={16} />
              {resultat}
            </li>
          ))}
        </ul>
      </div>

      {/* Outils utilisés */}
      <div className="bg-white border border-navy-100 rounded-2xl p-6 shadow-lg">
        <h3 className="text-xl font-semibold text-navy-900 mb-4 flex items-center gap-2">
          <Target className="text-blue-600" size={20} />
          Outils utilisés
        </h3>
        <div className="flex flex-wrap gap-2">
          {outils.map((outil, index) => (
            <span key={index} className="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm font-medium">
              {outil}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CompetenceResults;
